import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteLayout } from 'api/layout.service';
import { notificationActions } from 'redux/notification/notification.slice';

export const LAYOUT_DELETE_STORE_NAME = 'layoutDelete';

export const deleteLayouts = createAsyncThunk(
  `${LAYOUT_DELETE_STORE_NAME}/delete`,
  async (payload: { projectId: string, layoutId: string }, thunkAPI) => {
    const { projectId, layoutId } = payload;
    await deleteLayout(projectId, layoutId);
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.layoutDelete.success' }));
  },
);

export interface LayoutDeleteState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialLayoutDeleteState: LayoutDeleteState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const layoutDeleteSlice = createSlice({
  name: LAYOUT_DELETE_STORE_NAME,
  initialState: initialLayoutDeleteState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteLayouts.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(deleteLayouts.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(deleteLayouts.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const layoutDeleteActions = {
  ...layoutDeleteSlice.actions,
  deleteLayouts,
};

export default layoutDeleteSlice.reducer;
